module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dJLK7a/tc-custom/9781035802609.jpg?1705687882942",
      "alt": "This image is the cover for the book Knowledge, Power, Wealth and Wisdom"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Knowledge, Power, Wealth and Wisdom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Knowledge involves true belief and the realization of one’s own ignorance is the precondition for its attainment. Power is similar to distilled liquor; it will intoxicate and dim the judgment of even the most scrupulous men. Wealth is frequently associated with spiritual poverty and the distribution of wealth in any society exposes its lack of justice. Wisdom is combined with the trinity of values, which are, the absolute truth, the spirit of beauty and complete goodness. The man who is neither good nor wise remains self-satisfied. He has no desire to acquire that to which he feels no need. Aristotle insisted that life is the activity of the mind. Plato insisted that life is a preparation for death.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maurice Webb\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The Author’s experience was primarily technical. Obviously, Mathematics was absolutely necessary. He was influenced by Pythagoras who insisted that 1+2+3+4=10, is the perfect number. This is the base of our money and measurement system. Pythagoras is well known by his theorem. In a right angled triangle, the square of the hypotenuse is equal to the sum of the squares of the other two sides. Although Pythagoras discovered this theorem it existed long before Pythagoras was born. It is this a priori – assumptions about human nature; it has made progress in distinguishing the difference between man and beast. Metaphysics and ethics cannot be neglected.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0